<template>
	<ul class="nav-list" :class="_class" v-if="nav.length > 0">
		<li v-for="item in nav" :key="item.title">
			<a v-if="item.external" :href="item.url" target="_blank">
				<template v-if="item.title">{{ item.title }}</template>
				<i class="fa" :class="item.icon" v-if="item.icon"></i>
			</a>

			<a v-else-if="item.modal" @click.prevent="showModal(item.modal)">
				<template v-if="item.title">{{ item.title }}</template>
				<i class="fa" :class="item.icon" v-if="item.icon"></i>
			</a>

			<a v-else :href="item.url" exact>
				<template v-if="item.title">{{ item.title }}</template>
				<i class="fa" :class="item.icon" v-if="item.icon"></i>
			</a>
		</li>
	</ul>
</template>

<script>
export default {
	props: {
		nav: {
			required: true,
			type: Array,
			default: function() {
				return [];
			}
		},

		_class: {
			required: false,
			type: String,
			default: '-prefixed'
		}
	},

	methods: {
		showModal(id) {
			this.$root.$emit('showModal', id);
		}
	},

	watch: {
		nav: function(newValue, oldValue) {
			if (newValue === oldValue) return;

			this.nav = newValue;
		}
	}
};
</script>

<style lang="stylus">
.no-list-style

		&::before
			content: ''
			margin-right: 0.25rem
</style>
